const purposes = [
  {
    value: "mounting",
    title_eng: "Mounting",
    title_rus: "Монтаж"
  },
  {
    value: "demounting",
    title_eng: "Dismantling",
    title_rus: "Демонтаж"
  },
  {
    value: "transportation",
    title_eng: "Additional delivery during the exhibition running",
    title_rus: "Довоз во время выставки"
  }
];

export default purposes;
